export const sandboxRoutes = {
  root: "/sandbox",
  tab: "/sandbox/:tab",
  grid: "/sandbox/grids/:grid",
  ai: "/sandbox/ai",
} as const;
